import { Loader as LoaderMantine } from '@mantine/core'
import styled from 'styled-components'

export const Loader = styled(LoaderMantine)`
  & g:nth-last-child(1) circle:nth-last-child(2) {
    fill: none !important;
    opacity: 1 !important;
  }
`
